import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"

export type RotateWebhookSecretDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void | Promise<void>
  isProcessing?: boolean
}

export function RotateWebhookSecretDialog({
  open,
  onOpenChange,
  onConfirm,
  isProcessing,
}: RotateWebhookSecretDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (isProcessing) return
        onOpenChange(nextOpen)
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Rotate webhook secret?</DialogTitle>
          <DialogDescription className="text-left">
            This replaces the current webhook secret immediately. Deliveries signed with the
            previous secret will fail until callers use the new value. The new secret is shown
            once and cannot be viewed again.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            disabled={isProcessing}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={isProcessing}
            onClick={() => void onConfirm()}
          >
            {isProcessing ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Rotating…
              </>
            ) : (
              "Rotate secret"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
